export const joinProcessTractorOwnCheckConstants = {
  key: '트랙터 보유 유무',
  values: ['한대', '여러대', '없음'],
  labels: [],
};
